<template>
    <el-container class="home-c" :style="{ height: '100dvh' }">
        <el-aside :width="isCollapse ? '64px' : '220px'"
            style="background-color: #f5f5f5; transition: width 0.25s ease; overflow-x: hidden; overflow-y: auto;">
            <!-- 侧边栏 -->

            <div v-if="isCollapse" style="display: flex;flex-direction: column;justify-content: center;align-items: center;height: 90px;gap: 8px;">
                    <el-image style="width: 40px;height: 40px;" :src="require('@/assets/img/qhy2.png')"></el-image>
            </div>
            <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;height: 90px;gap: 8px;" v-else>
                <div style="display: flex;align-items: center;">
                    <el-image style="width: 32px;height: 32px;" :src="require('@/assets/img/qhy2.png')"></el-image>
                    <div style="font-weight: 600;color: #2e2bc6;margin-left: 5px;font-size: 16px;">{{ $siteConfig.siteName }}</div>
                </div>
                <!-- 前往2.0 -->
                <div class="go-v2" @click="$router.push('/home2')">
                    <span>前往 2.0 版本</span>
                    <app-icon  class="app-icon" style="font-size: 14px;" name="arrow_forward"></app-icon>
                </div>
            </div>
            <el-menu :default-active="activePath" :collapse="isCollapse" :collapse-transition="false" class="el-menu-vertical-demo" background-color="#f5f5f5"
                text-color="#333" active-text-color="#fffff" router>
                <el-menu-item index="/user/index" @click="saveNav('/user/index', '首页')">
                    <i class="el-icon-s-home"></i>
                    <span slot="title">首页</span>
                </el-menu-item>
                <el-menu-item index="/user/info" @click="saveNav('/user/info', '用户信息')">
                    <i class="el-icon-user"></i>
                    <span slot="title">我的信息&会员</span>
                </el-menu-item>
                <el-menu-item index="/user/vip" @click="saveNav('/user/vip', '购买会员')">
                    <i class="el-icon-present"></i>
                    <span slot="title">购买会员
                        <el-tag type="danger" size="mini">体验卡</el-tag>
                    </span>
                </el-menu-item>
                <el-menu-item index="/user/share" @click="saveNav('/user/share', '分享好友')">
                    <i class="el-icon-share"></i>
                    <span slot="title">分享好友
                        <el-tag type="danger" size="mini">有奖励</el-tag>
                    </span>
                </el-menu-item>
                <el-menu-item index="/user2/developer" @click="saveNav('/user2/developer', '代理后台')">
                    <i class="el-icon-s-cooperation"></i>
                    <span slot="title">代理后台</span>
                </el-menu-item>
                <div style="display: flex;justify-content: center;">
                    <el-divider></el-divider>
                </div>

                <el-menu-item index="/user/qc" @click="saveNav('/user/qc', '视频去重v1')">
                    <i class="el-icon-scissors"></i>
                    <span slot="title">视频去重v1</span>
                </el-menu-item>
                <el-menu-item index="/user/hj" @click="saveNav('/user/hj', '视频混剪v1')">
                    <i class="el-icon-refresh"></i>
                    <span slot="title">视频混剪v1</span>
                </el-menu-item>
                <el-menu-item index="/user/qcai" @click="saveNav('/user/qcai', '视频去重v2')">
                    <i class="el-icon-scissors"></i>
                    <span slot="title">视频去重v2</span>
                </el-menu-item>
                <el-menu-item index="/user/hj2" @click="saveNav('/user/hj2', '视频混剪v2')">
                    <i class="el-icon-refresh"></i>
                    <span slot="title">视频混剪v2</span>
                </el-menu-item>
                <!-- <el-menu-item index="/user/hjold" @click="saveNav('/user/hj', '混剪制作')">
                    <i class="el-icon-refresh"></i>
                    <span slot="title">混剪制作-旧</span>
                </el-menu-item> -->
                <!-- <el-menu-item index="/user/video_create" @click="saveNav('/user/video_create','视频生成')">
                    <i class="el-icon-film"></i>
                    <span slot="title">视频生成</span>
                </el-menu-item> -->
                <!-- <el-menu-item index="/user/qzm" @click="saveNav('/user/qzm', '视频去字幕')">
                    <i class="el-icon-brush"></i>
                    <span slot="title">视频去字幕</span>
                </el-menu-item> -->
                <el-menu-item index="/user/qihao" @click="saveNav('/user/qihao', '起号视频')">
                    <i class="el-icon-film"></i>
                    <span slot="title">起号视频</span>
                </el-menu-item>
                <el-menu-item index="/user/haowu" @click="saveNav('/user/haowu', '聚合好物')">
                    <i class="el-icon-s-promotion"></i>
                    <span slot="title">聚合好物
                        <!-- <el-tag type="danger" size="mini">内测</el-tag> -->
                    </span>
                </el-menu-item>

                <el-menu-item index="/user/ku" @click="saveNav('/user/ku', '混剪协同')">
                    <i class="el-icon-box"></i>
                    <span slot="title">混剪协同
                        <el-tag type="" size="mini">企业</el-tag>
                    </span>
                </el-menu-item>
                <el-menu-item index="/user/workflow" @click="saveNav('/user/workflow', '视频工作流')">
                    <i class="el-icon-s-operation"></i>
                    <span slot="title">视频工作流</span>
                </el-menu-item>

                <!-- <el-submenu>
                    <template slot="title">
                        <i class="el-icon-box"></i>
                        <span slot="title">视频仓库
                            <el-tag type="danger" size="mini" >vip</el-tag>
                        </span>
                    </template>
<el-menu-item-group>
    <el-menu-item index="/user/videohome" @click="saveNav('/user/videohome')">公开仓库</el-menu-item>
    <el-menu-item index="1-2">个人仓库</el-menu-item>
</el-menu-item-group>
</el-submenu> -->


                <el-menu-item index="/user/record" @click="saveNav('/user/record', '制作记录')">
                    <i class="el-icon-time"></i>
                    <span slot="title">制作记录</span>
                </el-menu-item>


                <div style="display: flex;justify-content: center;">
                    <el-divider></el-divider>
                </div>
            </el-menu>

            <div class="logout-menu-item" :class="{ 'is-collapse': isCollapse }" @click="outuser()">
                <i class="el-icon-switch-button"></i>
                <span v-if="!isCollapse">退出登录</span>
            </div>

        </el-aside>
        <el-container class="content-container" style="height: 100%; display: flex; flex-direction: column;">
            <el-header class="glass-header" style="height: auto; min-height: 50px; display: flex; align-items: center; justify-content: space-between; padding: 8px; box-sizing: border-box;
            flex-wrap: wrap;">
                <div @click="isCollapse = !isCollapse"
                    style="display: flex;align-items: center;cursor: pointer;padding: 5px;">
                    <i class="el-icon-s-fold" style="font-size:24px;color:#777;" v-if="!isCollapse"></i>
                    <i class="el-icon-s-unfold" style="font-size:24px;color:#777;" v-else></i>
                    <div style="font-size: 13px;color: #666;">功能列表</div>
                </div>
                <div style="display: flex; align-items: center; gap: 12px;">
                    <div class="header-user-info" @click="$router.push('/user/info')">
                        <app-icon  class="app-icon" style="font-size: 18px; color: #0052ff;" name="person"></app-icon>
                        <span style="font-size: 14px; color: #1a1a2e;">{{ phone }}</span>
                    </div>
                    <button class="header-btn-logout" @click="outuser">
                        <app-icon  class="app-icon" style="font-size: 18px;" name="logout"></app-icon>
                    </button>
                </div>
            </el-header>

            <el-main
                style="background-color: #f9f9f9; min-width: 326px; padding: 10px; overflow: auto;box-sizing: border-box; flex: 1;">
                <div style="display: flex; flex-direction: column; height: 100%;">
                    <div style="flex: 1; min-height: 0;">
                        <router-view />
                    </div>
                </div>
            </el-main>

        </el-container>

        <!-- 通知弹窗 -->
        <el-dialog title="系统通知" :visible.sync="noticeDialogVisible" width="500px" :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false" center>
            <div class="notice-content">
                <div class="notice-header">
                    <h3>{{ currentNotice.title }}</h3>
                    <span class="notice-time" v-if="currentNotice.time">{{ currentNotice.time }}</span>
                </div>
                <div class="notice-body">
                    <p>{{ currentNotice.content }}</p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <div class="notice-pagination">
                    <el-button :disabled="currentNoticeIndex === 0" @click="prevNotice" size="small"
                        icon="el-icon-arrow-left">
                        上一条
                    </el-button>
                    <span class="notice-counter">{{ currentNoticeIndex + 1 }} / {{ noticeList.length }}</span>
                    <el-button :disabled="currentNoticeIndex === noticeList.length - 1" @click="nextNotice"
                        size="small">
                        下一条
                        <i class="el-icon-arrow-right"></i>
                    </el-button>
                </div>
                <el-button type="primary" @click="closeNoticeDialog" size="small">我知道了</el-button>
            </div>
        </el-dialog>

    </el-container>
</template>

<script>
import { clearUserProfile } from '@/config/userProfile'

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Balance1 from './Balance.vue';
export default {
    name: '',
    components: {
        Balance1
    },
    // 定义属性
    data() {
        return {
            activePath: '',//激活路由地址
            isCollapse: false,
            dqym: '',
            gg: '欢迎使用',
            phone: '****',
            noticeDialogVisible: false, // 通知弹窗显示状态
            noticeList: [], // 通知列表
            currentNoticeIndex: 0, // 当前通知索引
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
        // 当前显示的通知
        currentNotice() {
            if (this.noticeList.length > 0 && this.currentNoticeIndex >= 0 && this.currentNoticeIndex < this.noticeList.length) {
                return this.noticeList[this.currentNoticeIndex]
            }
            return { title: '', content: '', time: '' }
        }
    },
    // 监控data中的数据变化
    watch: {
        '$route'(to) {
            this.activePath = to.path
        }
    },
    // 方法集合
    methods: {
        getUserInfo() {
            this.$ajax.get('api/v1/users/me').then(res => {
                if (res.data) {
                    this.phone = res.data.phone || '****'
                }
            }).catch(() => {})
        },
        get_balance() {
            this.$refs.Balance.get_user()
        },
        saveNav(path, name) {
            window.sessionStorage.setItem('activePath', path)
            window.sessionStorage.setItem('activePath_name', name)

            this.activePath = path
            this.dqym = name
        },
        outuser() {
            this.$confirm('确定要退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                window.localStorage.removeItem('token')
                window.sessionStorage.removeItem('userinfo')
                clearUserProfile()
                this.$router.push('/login')
            }).catch(() => {})
        },
        getCurrentMenu() {
            // // 获取当前页面 菜单刷新后能自动选中
            // let currentUrl = window.location.href
            // // console.log(currentUrl.split('#'))
            // let currentPage = currentUrl.split('#')[1]
            // // console.log(currentPage)
            // this.activePath = currentPage

            this.activePath = this.$route.path;
        },
        get_user() {
            this.$ajax.get('qhy/user/home').then(res => {
                // console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    // 检查是否有通知
                    if (res.data.notice && Array.isArray(res.data.notice) && res.data.notice.length > 0) {
                        // 过滤掉今天已查看的通知
                        const unreadNotices = this.filterUnreadNotices(res.data.notice)
                        if (unreadNotices.length > 0) {
                            this.noticeList = unreadNotices
                            this.currentNoticeIndex = 0
                            this.noticeDialogVisible = true
                        }
                    }
                } else {
                    this.$router.push('/login')
                }

            }).catch(err => {
                this.$router.push('/login')
                // console.log('failed', err);
            })
        },
        // 获取今天已查看的通知标识列表
        getTodayViewedNotices() {
            const today = new Date().toDateString()
            const viewedKey = `notice_viewed_${today}`
            const viewed = localStorage.getItem(viewedKey)
            return viewed ? JSON.parse(viewed) : []
        },
        // 记录今天已查看的通知
        markNoticeAsViewed(notice) {
            const today = new Date().toDateString()
            const viewedKey = `notice_viewed_${today}`
            const viewed = this.getTodayViewedNotices()
            // 使用 title + time 作为唯一标识
            const noticeId = `${notice.title}_${notice.time || ''}`
            if (!viewed.includes(noticeId)) {
                viewed.push(noticeId)
                localStorage.setItem(viewedKey, JSON.stringify(viewed))
            }
        },
        // 过滤未读通知
        filterUnreadNotices(notices) {
            const viewed = this.getTodayViewedNotices()
            return notices.filter(notice => {
                const noticeId = `${notice.title}_${notice.time || ''}`
                return !viewed.includes(noticeId)
            })
        },
        // 切换到上一条通知
        prevNotice() {
            if (this.currentNoticeIndex > 0) {
                this.currentNoticeIndex--
            }
        },
        // 切换到下一条通知
        nextNotice() {
            if (this.currentNoticeIndex < this.noticeList.length - 1) {
                this.currentNoticeIndex++
            }
        },
        // 关闭通知弹窗
        closeNoticeDialog() {
            // 标记所有通知为已查看
            this.noticeList.forEach(notice => {
                this.markNoticeAsViewed(notice)
            })
            this.noticeDialogVisible = false
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // console.log(111)
        this.getCurrentMenu()
        this.get_user()
        this.getUserInfo()
        // this.dqym= window.sessionStorage.getItem('activePath_name')
        // if (this.dqym == '' || this.dqym == undefined || this.dqym == null) {
        //     this.dqym='首页'
        // }

        // this.activePath = window.sessionStorage.getItem('activePath')
        // if (this.activePath == '' || this.activePath == undefined || this.activePath == null) {
        //     this.activePath = '/user/index'
        //     this.dqym = '首页'
        //     this.$router.push('/user/index')
        // } else {
        //     this.$router.push(this.activePath)
        //     this.dqym = window.sessionStorage.getItem('activePath_name')
        // }

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        window.screenWidth = document.body.clientWidth;
        if (window.screenWidth < 786) {
            this.isCollapse = true
        }
        // console.log(window.screenWidth)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.el-container {
    height: 100%;
}

.home-c {
    height: 100%;

}

.el-menu {
    border-right: none;
}

.el-menu-item.is-active {
    background-color: #ffffff !important;
    color: #313131 !important;
}

.el-divider--horizontal {
    margin: 12px 0;
    width: 85%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;

}

.el-menu-vertical-demo.el-menu--collapse {
    overflow-x: hidden;
}

.el-menu-item {
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin: 10px 10px;
    height: 40px;
    line-height: 40px;
    overflow: hidden;
}

.el-menu-item>>>.el-tooltip {
    /* display: flex !important;
    justify-content: center;
    align-items: center; */
    padding: 0px 10px !important;
}

.el-menu .el-menu-item:hover {
    /* outline: 0 !important; */
    /* color: rgb(79, 90, 220) !important; */
    background: #fff !important;

}

.el-menu .el-menu-item.is-active {
    color: rgb(79, 90, 220) !important;
    background: #fff !important;
}

.logout-menu-item {
    display: flex;
    align-items: center;
    margin: 10px;
    height: 40px;
    padding: 0 10px;
    border-radius: 5px;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    transition: background-color .2s;
}

.logout-menu-item i {
    margin-right: 8px;
    font-size: 17px;
}

.logout-menu-item:hover {
    background: #fff !important;
}

.logout-menu-item.is-collapse {
    justify-content: center;
    padding: 0;
}

.logout-menu-item.is-collapse i {
    margin-right: 0;
}

.el-aside::-webkit-scrollbar {

    display: none;

}

/* 关键样式 */
.el-main {
    overflow: auto;
    /* 内容溢出时显示滚动条（仅在内部滚动） */
}

.inner-container {
    height: calc(100% - 20px);
    /* 扣除 Balance1 组件的底部间距 */
    display: flex;
    flex-direction: column;
}

.content-area {
    flex: 1;
    /* 占据剩余空间 */
    min-height: 0;
    /* 解决 Flex 容器高度溢出问题 */
}

.content-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
}

.home-c {
    overflow: hidden;
    /* 防止整体容器滚动 */
}

/* 浅蓝色毛玻璃背景效果 */
.glass-header {
    background: rgba(254, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    position: relative;
}

.glass-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.1);
    pointer-events: none;
    z-index: -1;
}

/* Header 用户信息 */
.header-user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    background: #f5f7fa;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s;
}

.header-user-info:hover {
    background: #e5e7eb;
}

.header-btn-logout {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: none;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    color: #272a2f;
}

.header-btn-logout:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #ef4444;
}

/* 通知弹窗样式 */
.notice-content {
    min-height: 150px;
}

.notice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
}

.notice-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
}

.notice-time {
    font-size: 12px;
    color: #909399;
}

.notice-body {
    padding: 15px 0;
    line-height: 1.8;
    color: #606266;
    font-size: 14px;
}

.notice-body p {
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.notice-pagination {
    display: flex;
    align-items: center;
    gap: 15px;
}

.notice-counter {
    font-size: 14px;
    color: #606266;
    min-width: 60px;
    text-align: center;
}

/* 前往2.0按钮 */
.go-v2 {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    background: #e3f2fd;
    border-radius: 16px;
    font-size: 11px;
    font-weight: 600;
    color: #1a73e8;
    cursor: pointer;
    transition: all 0.2s;
}

.go-v2:hover {
    background: #bbdefb;
    transform: translateX(2px);
}
</style>



// WEBPACK FOOTER //
// src/components/User/Home.vue